// Libs
import React from 'react'
import { NavLink } from 'react-router-dom'

// CSS
import './styles.scss'

const HeaderMobileLink = ({ type, height, padding, ...props }) => {
  const headerMobileLinkStyle = {
    height: `${height}px`,
    padding: `${padding}`
  }

  return (
    <NavLink
      style={headerMobileLinkStyle}
      activeClassName="header-mobile__link--active"
      className={"header-mobile__link"}
      to={'em-análise'}
      {...props} />
  )
}

export default HeaderMobileLink
